import { Flag } from "@mui/icons-material";
import { IconProps, Tooltip, Typography } from "@mui/material";

interface Props {
  text?: string;
  color: string;
}

const AlertFlag = ({ color, text }: Props) => {
  const flagColor = color as IconProps["color"];

  return (
    <Tooltip
      data-testid="alertFlag"
      arrow
      title={text ? <Typography>{text}</Typography> : null}
      placement="top"
      sx={{ alignSelf: "end" }}
    >
      <Flag color={flagColor} />
    </Tooltip>
  );
};

export default AlertFlag;
